/**
  * Pushes an event to gtm
  *
  * @param {string} name - name of the event
  * @param {!Object} data - event data
  *
  */

export function pushEvent(name, data) {
  window.dataLayer.push(eventData(data));
}

/**
  * Returns a flattened event object for gtm
  *
  * @param {!Object} eventDataObject
  * @return {!Object}
  *
  */

function eventData(eventDataObject) {
  const {event, action, variables} = eventDataObject;
  return {
    event,
    ...action,
    ...variables,
  };
}
